import React, { useState } from "react";
import axiosInstance from "../../../../axios";
import "./requestDemo.scss";

const RequestDemo = () => {
  const [isActive, setIsActive] = useState(false);
  const [requestDemo, setRequestDemo] = useState({
    fullName: "",
    email: "",
    jobTitle: "NA",
    companyName: "NA",
    telephone: "",
    message: "NA",
    contactTime: "2021-02-02 14:00:00",
  });
  const [response, setResponse] = useState(null);

  const handleInputChange = (e) => {
    setRequestDemo({ ...requestDemo, [e.target.name]: e.target.value });
  };

  const shouldSubmit =
    requestDemo.fullName !== "" &&
    requestDemo.email !== "" &&
    isEmailAddress(requestDemo.email) &&
    requestDemo.telephone !== "";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (shouldSubmit) {
      try {
        const res = await axiosInstance.post("contact-us", requestDemo);
        if (!res.data.error) {
          setResponse({ error: false, message: res.data.message });
        } else {
          setResponse({ error: true, message: res.data.message });
        }
      } catch (error) {
        setResponse({ error: true, message: "" });
      }
    }
  };

  function isEmailAddress(email) {
    var pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return pattern.test(email);
  }

  if (response?.error) {
    return (
      <div className="demo-container">
        <div className={`demo-form ${isActive ? "active" : ""}`}>
          <div className="header">Request A Demo</div>
          <div
            className="close-button"
            onClick={() => setIsActive(false)}
          ></div>
          <div className="response-error">Something went wrong!</div>
        </div>
      </div>
    );
  }

  if (response && !response.error) {
    return (
      <div className="demo-container">
        <div className={`demo-form ${isActive ? "active" : ""}`}>
          <div className="header">Request A Demo</div>
          <div
            className="close-button"
            onClick={() => setIsActive(false)}
          ></div>
          <div className="response-success">
            Thank you for your interest. Our support team will contact you
            shortly!
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="demo-container">
      <button className="demo-button" onClick={() => setIsActive(true)}>
        <span className="demo-text">Request A Demo</span>
      </button>
      <div className={`demo-form ${isActive ? "active" : ""}`}>
        <div className="header">Request A Demo</div>
        <div className="close-button" onClick={() => setIsActive(false)}></div>
        <form onSubmit={() => null}>
          <input
            name="fullName"
            className="form-field"
            placeholder="Name"
            onChange={handleInputChange}
          />
          <input
            name="email"
            className="form-field"
            placeholder="Email"
            onChange={handleInputChange}
          />
          <input
            name="telephone"
            className="form-field"
            placeholder="Phone Number"
            onChange={handleInputChange}
          />
          <div className="purchaseBtn">
            <button
              className="demo-submit"
              onClick={handleSubmit}
              disabled={!shouldSubmit}
            >
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequestDemo;
